import { ApiService } from 'src/app/services/api/api.service';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { SignupService } from 'src/app/services/signup/signup.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import fakerbr from 'faker-br';
import { distinctUntilChanged } from 'rxjs/operators';
import Utils, { GetHelper, UtilsValidators } from 'src/app/helpers/utils';
import { ToastService } from 'src/app/services/toast/toast.service';
import { MaskPipe } from 'ngx-mask';

@Component({
  selector: 'app-signup-unified-person-complementary-bank',
  templateUrl: './signup-unified-person-complementary-bank.component.html',
  styleUrls: ['./signup-unified-person-complementary-bank.component.scss'],
})
export class SignupUnifiedPersonComplementaryBankComponent
  implements OnInit, OnDestroy
{
  @Input() userRole: string;

  form = this.formBuilder.group({
    bank: [null, []],
    agency: [null, []],
    account_number: [null, []],
    account_type: [null, []],
    account_digit: [null, []],
    joint_account: [false, []],

    main_account: [false, []],
    // not_owner: [false, []],
    // person_document_number: [null, []],
    // joint_holders_identification: [null, []],
  });

  accountTypes: SelectItem[] = [
    { label: 'Conta Corrente', value: '1' },
    { label: 'Conta Poupança', value: '2' },
  ];

  showForm = true;

  columns: TableColumn<PersonComplementaryBankValues>[] = [
    {
      name: 'Banco',
      cell: (row) => `
        <span>${row.bank ? this.formatBankName(row.bank.name) : ''}</span>
        <span class="table-subtitle">${
          row.main_account ? 'Conta Principal' : ''
        }</span>
      `,
    },
    { name: 'Agência', cell: (row) => row.agency },
    {
      name: 'Conta',
      cell: (row) =>
        `
      <span>
      ${
        row.account_digit
          ? row.account_number + '-' + row.account_digit
          : row.account_number
      }
      </span>
      <span class="table-subtitle">
      ${
        this.accountTypes.find(
          (item) => item.value === String(row.account_type)
        )?.label
      }
      </span>
         `,
    },
    // {
    //   name: 'Co-titular',
    //   cell: (row) => `
    //   <span>${row.joint_holders_identification ?? ''}</span>
    //   <span class="table-subtitle">${
    //     row.person_document_number
    //       ? this.formatDocument(row.person_document_number)
    //       : ''
    //   }</span>
    //   `,
    // },
  ];

  data: BankResponse[] = [];

  cpfErrorMessage = 'Documento inválido';

  banks: Bank[] = [];

  addAnotherModal = false;
  confirmMainAccountModal = false;

  removeModal = false;
  selectedIndex = 0;
  removingBank = false;
  isConfirmingMainAccount = false;
  editingBank: BankResponse | null = null;
  isFillingForm = false;

  loading = true;

  sending = false;

  event: any;

  constructor(
    private formBuilder: FormBuilder,
    public signupService: SignupService,
    private api: ApiService,
    private toast: ToastService,
    private maskPipe: MaskPipe,
    private route: ActivatedRoute,
    private authService: AuthService
  ) {}

  ngOnDestroy(): void {
    this.event.unsubscribe();
  }

  ngOnInit(): void {
    this.signupService.choicesFetchedEvent.subscribe((choices) => {
      this.loading = false;
    });

    this.event = this.signupService.sendPersonData.subscribe((value) => {
      if (value === 'complementaryBank') {
        this.signupService.setPersonStep('complementaryProfessional');
        this.signupService.changePersonStepEvent.emit('professional');
      }
    });

    this.getDataAndFillForm();

    this.banks = this.signupService.signupData.banks;

    this.form.controls.main_account.valueChanges.subscribe((value) => {
      // Só verifica se não estiver preenchendo o formulário (edição) e não estiver confirmando
      if (value && !this.isConfirmingMainAccount && !this.isFillingForm) {
        const hasMainAccount = this.data.some((item) => item.main_account);

        if (hasMainAccount) {
          this.confirmMainAccountModal = true;
        }
      }
    });

    // this.form.controls.not_owner.valueChanges.subscribe((value) => {
    //   if (value) {
    //     this.form.controls.person_document_number.setValidators([
    //       Validators.required,
    //       UtilsValidators.cpf,
    //     ]);
    //     this.form.controls.joint_holders_identification.setValidators([
    //       Validators.required,
    //     ]);
    //   } else {
    //     this.form.controls.person_document_number.setValidators([]);
    //     this.form.controls.person_document_number.setValue(null);
    //     this.form.controls.joint_holders_identification.setValidators([]);
    //     this.form.controls.joint_holders_identification.setValue(null);
    //   }

    //   this.form.controls.person_document_number.updateValueAndValidity();
    //   this.form.controls.joint_holders_identification.updateValueAndValidity();
    // });

    // this.form.controls.person_document_number.valueChanges
    //   .pipe(distinctUntilChanged((a: any, b: any) => a === b))
    //   .subscribe((value) => {
    //     this.cpfErrorMessage = 'Documento inválido';

    //     if (value && value.length === 14) {
    //       const formattedValue = Utils.onlyNumbers(value);

    //       if (formattedValue === this.generalDocument) {
    //         this.form.controls.person_document_number.setErrors({ cpf: true });

    //         this.cpfErrorMessage = 'CPF não pode ser igual ao seu documento';
    //       }
    //     }
    //   });

    this.form.controls.bank.valueChanges
      .pipe(distinctUntilChanged((a: any, b: any) => a === b))
      .subscribe((value) => {
        if (value !== null) {
          this.form.controls.bank.setValidators([Validators.required]);
          this.form.controls.agency.setValidators([Validators.required]);
          this.form.controls.account_number.setValidators([
            Validators.required,
          ]);
          this.form.controls.account_type.setValidators([Validators.required]);

          if (this.userRole === 'provider') {
            // Para provider, só habilita se houver pelo menos uma conta bancária adicionada
            this.signupService.setPersonFormStatus(
              'complementaryBank',
              this.data.length > 0
            );
          }
        } else {
          const validators =
            this.userRole !== 'provider' ? [Validators.required] : [];

          this.form.controls.bank.setValidators(validators);
          this.form.controls.agency.setValidators(validators);
          this.form.controls.account_number.setValidators(validators);
          this.form.controls.account_type.setValidators(validators);
          this.form.controls.account_digit.setValidators([]);

          this.form.controls.bank.setValue(null);
          this.form.controls.agency.setValue(null);
          this.form.controls.account_number.setValue(null);
          this.form.controls.account_digit.setValue(null);
          this.form.controls.account_type.setValue(null);

          if (this.userRole === 'provider') {
            // Para provider, só habilita se houver pelo menos uma conta bancária adicionada
            this.signupService.setPersonFormStatus(
              'complementaryBank',
              this.data.length > 0
            );
          }
        }

        if (this.userRole !== 'provider') {
          this.form.statusChanges.subscribe((status) => {
            if (!this.addAnotherModal) {
              this.signupService.setPersonFormStatus(
                'complementaryBank',
                this.data.length > 0
              );
            }
          });
        }

        this.form.controls.bank.updateValueAndValidity();
        this.form.controls.agency.updateValueAndValidity();
        this.form.controls.account_number.updateValueAndValidity();
        this.form.controls.account_type.updateValueAndValidity();
        this.form.controls.account_digit.updateValueAndValidity();
      });

    this.signupService.fillFormEvent.subscribe(() => {
      this.form.patchValue({
        bank: String(fakerbr.random.number({ min: 1, max: 320 })),
        agency: String(fakerbr.random.number({ min: 1000, max: 9999 })),
        account_number: String(
          fakerbr.random.number({ min: 1000000, max: 9999999 }) +
            '-' +
            fakerbr.random.number({ min: 0, max: 9 })
        ),
        account_digit: String(fakerbr.random.number({ min: 1, max: 9 })),
        account_type: '1',
        joint_account: false,
        // person_document_number: '',
        // joint_holders_identification: '',
      });
    });

    // this.form.controls.joint_account.valueChanges.subscribe((value) => {
    //   if (value) {
    //     this.form.controls.cpf.setValidators([
    //       Validators.required,
    //       UtilsValidators.cpf,
    //     ]);
    //     this.form.controls.joint_holders_identification.setValidators([
    //       Validators.required,
    //     ]);
    //   } else {
    //     this.form.controls.cpf.setValidators([]);
    //     this.form.controls.joint_holders_identification.setValidators([]);
    //   }

    //   this.form.controls.cpf.updateValueAndValidity();
    //   this.form.controls.joint_holders_identification.updateValueAndValidity();
    // });
  }

  /**
   * Obtém o register_uuid da URL (obrigatório, sem fallback)
   */
  private getRegisterUuid(): string | null {
    return this.route.snapshot.paramMap.get('id');
  }

  /**
   * Obtém os params com register_uuid para as chamadas da API
   */
  private getRegisterParams(): any {
    const routeId = this.getRegisterUuid();

    if (!routeId) {
      this.toast.show('error', 'Erro', 'Register UUID não encontrado na rota');
      return null;
    }

    return { register_uuid: routeId };
  }

  async getDataAndFillForm() {
    this.loading = true;
    try {
      const params = this.getRegisterParams();

      const { data } = await this.api.get<ApiResponse<BankResponse[]>>({
        route: 'api/registration/bank-account/',
        params: params,
        token: true,
      });

      this.showForm = !(data.length > 0);

      this.signupService.setPersonFormStatus(
        'complementaryBank',
        data.length > 0
      );

      // Ordena os dados para que a conta principal apareça sempre primeiro
      this.data = data.sort((a, b) => {
        if (a.main_account && !b.main_account) return -1;
        if (!a.main_account && b.main_account) return 1;
        return 0;
      });
    } catch (error) {
      if (error.status !== 404) {
        this.toast.show('error', 'Erro', error.error.message);
      }
    }
    this.loading = false;
  }

  async sendData() {
    this.sending = true;
    try {
      const valuesHelper = new GetHelper(this.form.value);

      const main_account = valuesHelper.get('main_account') ?? false;

      // Só verifica duplicatas se não estiver editando
      if (!this.editingBank) {
        const filteredBanks = this.data.filter(
          (item) => item.bank.id === Number(valuesHelper.get('bank'))
        );

        const bankExists = filteredBanks.map((item) => {
          const agencyExistis =
            String(item.agency) === valuesHelper.get('agency');
          const checkingAccountExists =
            String(item.account_number) === valuesHelper.get('account_number');
          const checkingAccountDigitExists =
            item.account_digit === valuesHelper.get('account_digit');

          return (
            agencyExistis && checkingAccountExists && checkingAccountDigitExists
          );
        });

        if (bankExists.some((item) => item)) {
          this.toast.show('error', 'Erro', 'Banco já cadastrado');
          return;
        }
      }

      if (main_account && this.data.length > 0) {
        const idx = this.data.findIndex((item) => item.main_account);
        const params = this.getRegisterParams();

        await this.api.patch<ApiResponse<BankResponse>>({
          route: `api/registration/bank-account/${this.data[idx].id}/`,
          params: params,
          token: true,
          body: {
            main_account: false,
          },
        });
      }

      const payload = {
        bank: valuesHelper.get('bank'),
        agency: Number(Utils.onlyNumbers(valuesHelper.get('agency'))),
        account_number: Number(
          Utils.onlyNumbers(valuesHelper.get('account_number'))
        ),
        account_digit: valuesHelper.get('account_digit')
          ? Number(Utils.onlyNumbers(valuesHelper.get('account_digit')))
          : null,
        joint_account: valuesHelper.get('joint_account') ?? false,
        account_owner: true,
        // person_document_number: Utils.onlyNumbers(
        //   valuesHelper.get('person_document_number')
        // ),
        // joint_holders_identification: valuesHelper.get(
        //   'joint_holders_identification'
        // ),
        main_account: this.data.length > 0 ? main_account : true,
        account_type: this.form.controls.account_type.value,
      };

      console.table(valuesHelper.getRemainingObject());

      const params = this.getRegisterParams();

      let response: ApiResponse<BankResponse>;

      if (this.editingBank) {
        // PATCH para atualizar conta existente
        response = await this.api.patch<ApiResponse<BankResponse>>({
          route: `api/registration/bank-account/${this.editingBank.id}/`,
          params: params,
          token: true,
          body: payload,
        });
      } else {
        // POST para criar nova conta
        response = await this.api.post<ApiResponse<BankResponse>>({
          route: 'api/registration/bank-account/',
          params: params,
          token: true,
          body: payload,
        });
      }

      if (this.data.length > 0) {
        this.showForm = false;
      }

      // Prepara mensagem antes de limpar o estado
      const isEditing = !!this.editingBank;
      const message = isEditing
        ? 'Conta bancária atualizada com sucesso!'
        : response.message || 'Conta bancária salva com sucesso!';

      // Fecha o modal primeiro
      this.handleCloseModal();

      // Limpa o estado de edição
      this.editingBank = null;

      // Mostra o toast imediatamente após o sucesso
      this.toast.show('info', 'Sucesso', message);

      // Atualiza a lista de contas (com loading spinner) - DEPOIS de fechar o modal
      await this.getDataAndFillForm();
      
      // Atualiza o status do formulário após adicionar/editar conta
      // Para provider, só habilita se houver pelo menos uma conta bancária
      if (this.userRole === 'provider') {
        this.signupService.setPersonFormStatus(
          'complementaryBank',
          this.data.length > 0
        );
      }
    } catch (error) {
      console.error(error);
      this.toast.show(
        'error',
        'Erro',
        error.error?.message || 'Erro ao salvar conta bancária'
      );
      // Em caso de erro, o modal permanece aberto
    } finally {
      this.sending = false;
    }
  }

  handleOpenRemoveModal(index: number) {
    this.removeModal = true;
    this.selectedIndex = index;
  }

  handleOpenEditModal(index: number) {
    const bankData = this.data[index];
    this.editingBank = bankData;
    this.addAnotherModal = true;

    // Flag para indicar que estamos preenchendo o formulário
    this.isFillingForm = true;

    // Preenche o formulário com os dados existentes
    this.form.patchValue({
      bank: bankData.bank?.id?.toString() || bankData.bank,
      agency: bankData.agency?.toString(),
      account_number: bankData.account_number?.toString(),
      account_digit: bankData.account_digit?.toString() || null,
      account_type: bankData.account_type?.toString(),
      main_account: bankData.main_account || false,
      joint_account: bankData.joint_account || false,
    });

    // Remove a flag após um pequeno delay para permitir que o formulário seja preenchido
    setTimeout(() => {
      this.isFillingForm = false;
    }, 100);
  }

  handleRemoveCancel() {
    this.removeModal = false;
    this.confirmMainAccountModal = false;
    this.selectedIndex = 0;
    this.removingBank = false;
  }

  handleConfirm(value: boolean) {
    this.isConfirmingMainAccount = true;
    this.confirmMainAccountModal = false;

    // Use setTimeout to ensure modal closes first, then set the value
    setTimeout(() => {
      this.form.controls.main_account.setValue(value, { emitEvent: false });
      this.form.controls.main_account.updateValueAndValidity();

      // Reset flag after a short delay
      setTimeout(() => {
        this.isConfirmingMainAccount = false;
      }, 50);
    }, 50);
  }

  async removeBank(index: number) {
    this.removingBank = true;
    try {
      const findedBank = this.data[index];
      const params = this.getRegisterParams();

      await this.api.delete({
        route: `api/registration/bank-account/${findedBank.id}/`,
        params: params,
        token: true,
      });

      this.removeModal = false;

      this.toast.show('info', 'Sucesso', 'Conta removida com sucesso');

      const filtered = this.data.filter((item) => item.id !== findedBank.id);
      const haveMainAccount = filtered.some((item) => item.main_account);

      if (filtered.length >= 1 && !haveMainAccount) {
        if (!filtered[0].main_account) {
          const params = this.getRegisterParams();
          await this.api.patch<ApiResponse<BankResponse>>({
            route: `api/registration/bank-account/${filtered[0].id}/`,
            params: params,
            token: true,
            body: {
              main_account: true,
            },
          });
        }
      }

      await this.getDataAndFillForm();

      // Atualiza o status do formulário após remover conta
      // Para provider, só habilita se houver pelo menos uma conta bancária
      if (this.userRole === 'provider') {
        this.signupService.setPersonFormStatus(
          'complementaryBank',
          this.data.length > 0
        );
      }
    } catch (error) {
      this.toast.show('error', 'Erro', error.error.message);
    } finally {
      this.removingBank = false;
    }
  }

  getDisabled() {
    if (this.addAnotherModal) {
      return this.form.invalid || !this.form.controls.bank.value;
    }

    if (this.showForm) {
      if (this.form.controls.bank.value === null) {
        return true;
      } else {
        return this.form.invalid;
      }
    }

    return false;
  }

  triggerForm() {
    if (this.addAnotherModal) {
      // Quando está no modal, apenas chama sendData
      // O modal será fechado pelo handleCloseModal() apenas se der sucesso
      this.sendData();
    } else {
      if (this.data.length === 0) {
        this.sendData();
      } else {
        this.addAnotherModal = true;
        this.signupService.setPersonFormStatus('complementaryBank', false);
      }
    }
  }

  closeModal() {
    this.addAnotherModal = false;
  }

  handleCloseModal() {
    this.addAnotherModal = false;
    this.editingBank = null;
    this.isFillingForm = false;
    this.signupService.setPersonFormStatus(
      'complementaryBank',
      this.data.length > 0
    );
    this.form.reset();
  }

  formatBankName(bankName: string) {
    if (bankName.length > 48) {
      const words = bankName.split(' ');
      const firstLine = words.slice(0, 6).join(' ');
      const secondLine = words.slice(6, words.length).join(' ');

      return secondLine.length > 0
        ? `${firstLine} <br> ${secondLine}`
        : `${firstLine}`;
    }
    return bankName;
  }

  formatDocument(value) {
    return this.maskPipe.transform(value, '000.000.000-00');
  }

  handleKeyEnter(event: any) {
    event.preventDefault();
    if (event.keyCode === 13 && this.form.valid) {
      this.triggerForm();
    }
  }
}
